import { z } from 'zod/mini'

type CheckoutStepEvent = {
  has_trade_in: boolean
  ecommerce: { items: unknown[] }
}

/**
 * A cart can hold a trade-in only (no product), so checkout funnel events may
 * legitimately have no items. Otherwise an empty `items` array is a bug.
 */
export const requireItemsUnlessTradeInOnly = <T extends CheckoutStepEvent>() =>
  z.refine<T>(
    (event) => event.ecommerce.items.length > 0 || event.has_trade_in,
    {
      message: 'must not be empty without a trade-in',
      path: ['ecommerce', 'items'],
    },
  )
